import axios from './axiosInstances/identityAxiosInstance';

const api = {
  async deleteSharedProfile({ userId, toId }) {
    return axios.post('/shares/softDelete', { userId, toId });
  },
};
export default api;
